import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasMijas() {
  return (
    <CityPagePersianas
      name="Mijas"
      slug="mijas"
      cp="29649, 29650, 29651"
      poblacion={94320}
      zonaGeo="Costa del Sol Occidental"
      lat={36.5953}
      lng={-4.6371}
      zonas={[
        "Mijas Pueblo",
        "Mijas Costa",
        "La Cala de Mijas",
        "Calahonda",
        "Riviera del Sol",
        "Las Lagunas",
        "El Faro",
      ]}
      landmarks={[
        "Mijas Pueblo casco antiguo",
        "Plaza Virgen de la Peña",
        "Hipódromo Costa del Sol",
      ]}
      municipiosLimitrofes={[
        "Fuengirola",
        "Benalmádena",
        "Marbella",
        "Ojén",
        "Coín",
        "Alhaurín el Grande",
      ]}
      festivalLocal="Feria de Mijas, segunda semana de septiembre"
      contextoTipologico="Casas blancas tradicionales del pueblo blanco, urbanizaciones modernas La Cala-Calahonda, mix expat y residentes locales."
      isCoreZone={true}
    />
  );
}